import MDBox from "../../../../components/MDBox";
import {
    Dialog,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormGroup, Radio, RadioGroup, Tooltip,
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import MDTypography from "../../../../components/MDTypography";
import React, {useEffect, useState} from "react";
import MDButton from "../../../../components/MDButton";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import PaperComponent from "../../../../components/MuiDraggableDialog";
import {
    cargoOwnerCarrierEdit,
    cargoOwnerInfo,
    cargoOwnerStorageFeeTermEdit,
    getAllWarehouseList,
} from "../../../../actions/inventory/inventoryAction";
import {useDispatch, useSelector} from "react-redux";
import {LoadingButton} from "@mui/lab";
import FramerFade from "../../../../components/Animation/Fade";
import LocalStorage from "../../../../utils/LocalStorage";
import {getUserSetting, Logout, onErrorAlert, onSuccessAlert} from "../../../../actions";
import {noop} from "lodash";
import {checkPermission, PERMISSION_DICT} from "../../../../utils/Users_Roles_Permission";
import IconButton from "@mui/material/IconButton";
import InfoIcon from "@mui/icons-material/Info";
import {createTheme, ThemeProvider} from "@mui/material/styles";
import {useTranslation} from "react-i18next";
const muiTheme = createTheme({
    slider: {
        trackColor: "yellow",
        selectionColor: "green"
    }
});


const PaymentTermEdit = ({setOpen, open,onInfoSuccess}) => {
    const storageFeePaymentTermArr = [
        {
            id: 1,
            value: '1',
            label: 'Monthly'
        },
        {
            id: 2,
            value: '2',
            label: 'Weekly'
        },


    ]
    const [view, setView] = useState("preview")
    const haveCard = useSelector(state => state?.system?.haveCard,(prev, next) => prev === next)
    const ownerInfo = useSelector(state => state?.inventory?.ownerInfo,(prev, next) => prev === next)
    const [activeStep, setActiveStep] = useState(0);
    const [loading, setLoading] = useState(false)
    const [storageFeeTerm, setStorageFeeTerm] = useState('Monthly');
    const dispatch = useDispatch()
    const {t} = useTranslation()

    useEffect(() => {
        if (!!ownerInfo?.ownerResp?.storageFeeTerm){
            setStorageFeeTerm(storageFeePaymentTermArr.find((e)=> e.value === ownerInfo?.ownerResp?.storageFeeTerm).label)
        }else{

        }
    },[ownerInfo])

    useEffect(() => {
        if (open === true ){
            if (!!ownerInfo?.ownerResp?.storageFeeTerm){
                setStorageFeeTerm(storageFeePaymentTermArr.find((e)=> e.value === ownerInfo?.ownerResp?.storageFeeTerm).label)
            }else {
                setStorageFeeTerm('Monthly')
            }

        }
    },[open])

    const handleStorageFeeTermChange = (event) => {
        setStorageFeeTerm(event.target.value);
    };

    const onSuccess = async (msg) => {
        dispatch(onSuccessAlert((msg)))
            dispatch(cargoOwnerInfo({ ownerId: ownerInfo?.ownerResp?.ocpOwnerId,
                userName: LocalStorage.getItem('username')},onInfoSuccess))
        setOpen(false)
        setLoading(false)
        setView("preview")
        setActiveStep(0)
    }
    const onError = (msg, code) => {
        dispatch(onErrorAlert(msg))
        setLoading(false)
        if (code === 401) {
            dispatch(Logout(noop))
            nav('/')
        }
    }

    return (
        <React.Fragment>
            <Dialog
                PaperComponent={PaperComponent}
                fullWidth
                maxWidth={'md'}
                open={open}
                onClose={() => {
                    setOpen(false)
                    setView("preview")
                    setActiveStep(0)
                }}
                aria-labelledby="draggable-dialog-title"
            ><DialogTitle id="draggable-dialog-title" style={{cursor: 'move'}}>
                <MDTypography variant={'h5'}>
                </MDTypography>
            </DialogTitle>
                <DialogContent>
                    <MDBox
                        variant="gradient"
                        bgColor="info"
                        borderRadius="lg"
                        coloredShadow="success"
                        mx={2}
                        mt={2}
                        p={3}
                        mb={1}
                        textAlign="center"
                    >
                        <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                            {t('CustomerPage.Storage Fee Setting')}
                        </MDTypography>
                    </MDBox>
                    <MDBox pb={2} px={3} sx={{overflow: "hidden"}}>
                        <FramerFade isActive={activeStep === 0} delay={0}>
                            <MDBox component="form" role="form">
                                <div style={{overflow: "hidden"}}>
                                    <MDBox>
                                        <FormControl sx={{width:"100%"}}>
                                            <MDBox mt={1}  sx={{display:"flex", alignItems:"center", justifyContent:"space-between", width:"100%"}}>
                                                <MDTypography variant="caption" fontWeight="bold"  textTransform="uppercase">
                                                    {t('CustomerPage.Storage Fee Payment Term')}:
                                                </MDTypography>
                                            </MDBox>
                                            <ThemeProvider theme={muiTheme}>
                                                <MDBox>
                                                    <RadioGroup
                                                        row
                                                        aria-labelledby="demo-controlled-radio-buttons-group"
                                                        name="controlled-radio-buttons-group"
                                                        value={storageFeeTerm}
                                                        onChange={handleStorageFeeTermChange}
                                                    >
                                                        <MDBox>
                                                            <FormControlLabel value="Monthly" control={<Radio size="small"/>}
                                                                              label={
                                                                                  <MDTypography variant="button" fontWeight="regular"
                                                                                                color="text">
                                                                                      {t('Monthly')}
                                                                                  </MDTypography>}
                                                            />
                                                        </MDBox>
                                                        <MDBox ml={2}>
                                                            <FormControlLabel value="Weekly" control={<Radio size="small"/>}
                                                                              label={
                                                                                  <MDTypography variant="button" fontWeight="regular"
                                                                                                color="text">
                                                                                      {t('Weekly')}
                                                                                  </MDTypography>}
                                                            />
                                                        </MDBox>


                                                    </RadioGroup>
                                                </MDBox>
                                            </ThemeProvider>
                                        </FormControl>
                                    </MDBox>
                                    <MDBox mt={3} sx={{display: "flex", justifyContent: "flex-end"}}>
                                        <MDButton sx={{marginRight: "20px"}} variant="outlined" color="info"
                                                  onClick={() => {
                                                        setLoading(false)
                                                          setOpen(false)
                                                          setView("preview")
                                                          setActiveStep(0)
                                                      }
                                                  }>
                                            {t('Cancel')}
                                        </MDButton>
                                        <LoadingButton
                                            disabled={!checkPermission(PERMISSION_DICT.CustomerCargoStorageFeeTermModify)}
                                            loading={loading}
                                            variant="contained"
                                            onClick={() => {
                                                    setLoading(true)
                                                    dispatch(cargoOwnerStorageFeeTermEdit(
                                                        {
                                                            omsOwnerId:ownerInfo?.ownerResp?.omsOwnerId,
                                                            storageFeeTerm:storageFeePaymentTermArr.find((e)=>e.label === storageFeeTerm)? storageFeePaymentTermArr.find((e)=>e.label === storageFeeTerm).value : storageFeePaymentTermArr[0].value
                                                        },onSuccess,onError
                                                    ))
                                            }}
                                        >
                                            {t('Confirm')}
                                        </LoadingButton>
                                    </MDBox>
                                </div>
                            </MDBox>
                        </FramerFade>
                    </MDBox>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    )
}

export default PaymentTermEdit